import React, {useEffect, useState, useRef, forwardRef} from 'react';
import Api from './Api';
import ReCAPTCHA from 'react-google-recaptcha'

const Contact = () => {

  const [pathName, setPathName] = useState("");
  const recaptcha = useRef();

  async function onZohoFormSubmit(e) {
    
    
    const captchaValue = await recaptcha.current.getValue();        
    if (!captchaValue) {
      e.preventDefault();
      alert('Please verify the reCAPTCHA!');        
      return;
    } 

    let verifyUrl = `${process.env.CAPTCHA_VERIFY_URL}`;

    const res = await fetch(verifyUrl, {
        method: 'POST',
        body: JSON.stringify({ "captchaValue" : captchaValue }),
        headers: {
          'content-type': 'application/json',
        },
      })
      const data = await res.json();
      if (data != true) {
        e.preventDefault();
        recaptcha.current.reset();
        alert('reCAPTCHA validation failed!  Please verify reCAPTCHA again!');        
        return;
      } 
    
    setTimeout(() => { 
      const contactForm = document.getElementById("webform4295798000022107021_contact");
      contactForm.classList.remove("was-validated");
      contactForm.reset();
      recaptcha.current.reset();
      document.querySelector("section#contact div.sent-message").style.display = 'block';
    }, 1000);
  }

  useEffect(() => {

      async function submitContactUs(contactForm) {
        const userFname = document.getElementById("txt_ctct_firstname").value;
        const userLname = document.getElementById("txt_ctct_lastname").value;
        const userEmail = document.getElementById("txt_ctct_email").value;
        const userPhone = document.getElementById("txt_ctct_phone").value;
        const userCompany = document.getElementById("txt_ctct_company").value;
        const userMessage = document.getElementById("txt_ctct_message").value;

        const postBody = {
          "postUrl": "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
          "formFields": {
            "oid": `${process.env.SALESFORCE_ORG}`, //Put your ORGID here
            "retURL": "http://127.0.0.1", //Dummy Url
            "first_name": userFname,
            "last_name": userLname,
            "company": userCompany,
            "email": userEmail,
            "phone": userPhone,
            "00N3m00000QFhWn": userMessage
          }
        }
        
        // this sends the email via api
        let apiObj = new Api();
        let sendResults = await apiObj.sendSalesForceForm(postBody, "spinner-sendmail");
        switch(sendResults.message.toUpperCase()) {
          case "SUCCESS":
            const contactForm = document.getElementById("form_ctct");
            contactForm.classList.remove("was-validated");
            contactForm.reset();
            document.querySelector("section#contact div.sent-message").style.display = 'block';
            break;
          default:
            // @todo - fail code block
        }
      }

      // document.getElementById("but_ctct_contactSubmit").addEventListener('click',      
      //   (event) => {
      //     event.preventDefault()
      //     event.stopPropagation()
      //     const contactForm = event.target.form;
      //     if (contactForm.checkValidity()) {
      //       submitContactUs(contactForm);
      //     }
      //     contactForm.classList.add('was-validated')
      // });

      setPathName(window.location.pathname)

    }, []);


    return (
        <>
        {(pathName !== "/info" || pathName !== "/info/") && 
          <section id="contact" className="contact section-bg">
            <div className="container" data-aos="fade-up">

              <div className="section-title">
                
                <h3>Contact <span>Us</span></h3>
                <p>Our team is hands-on and knowledgeable, reach out to us for any consultation needs or questions.</p>
              </div>

              <div className="row" data-aos="fade-up" data-aos-delay="100">

                <div className="col-lg-6 col-md-6">
                  <div className="info-box  mb-4">
                  <i class="bi bi-envelope"></i>
                    <h3>Email Us</h3>
                    <p>info@level1analytics.com</p>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="info-box  mb-4">
                  <i class="bi bi-telephone"></i>
                    <h3>Call Us</h3>
                    <p>+1 954-483-3424</p>
                  </div>
                </div>

              </div>

              {/* <div className="row" data-aos="fade-up" data-aos-delay="100" style={{border: '1px solid lime'}}>

                <div className="col-md-12">
                  <form role="form" className="php-email-form needs-validation" id="form_ctct" novalidate>
                    <div className="row">
                      <div className="col form-group">
                        <input type="text" className="form-control" id="txt_ctct_firstname" title="First Name" placeholder="First Name" aria-describedby="FirstName" required />
                        <div class="invalid-feedback">
                          Please provide your first name.
                        </div>
                      </div>
                      <div className="col form-group">
                        <input type="text" className="form-control" id="txt_ctct_lastname" title="Last Name" placeholder="Last Name" aria-describedby="LastName" required />
                        <div class="invalid-feedback">
                          Please provide your last name.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col form-group">
                        <input type="email" className="form-control" id="txt_ctct_email" title="Email" placeholder="Email" aria-describedby="Email" required />
                          <div className="invalid-feedback">
                            Please provide your email.
                          </div>
                      </div>
                      <div className="col form-group">
                        <input type="phone" className="form-control" id="txt_ctct_phone" placeholder="Phone" aria-describedby="Phone" />
                      </div>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control" id="txt_ctct_company" title="Company" placeholder="Company" aria-describedby="Company" required/>
                      <div className="invalid-feedback">
                        Please provide your company.
                      </div>
                    </div>
                    <div className="form-group">
                      <textarea className="form-control" id="txt_ctct_message" title="Message" placeholder="Message" aria-describedby="Message" required></textarea>
                        <div className="invalid-feedback">
                          Please provide your message.
                        </div>
                    </div>
                    <div className="my-3">
                      <div className="loading">Loading</div>
                      <div className="error-message"></div>
                      <div className="sent-message">Your message has been sent. Thank you!</div>
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary form-control" id="but_ctct_contactSubmit">
                        <i className="spinner-border spinner-border-sm buttonspinner" role="status" id="spinner-sendmail"></i> Send
                      </button>
                    </div>
                  </form>
                </div>
              </div> */}

              <div className="row" data-aos="fade-up" data-aos-delay="100" style={{border: '1px solid transparent'}}>

                <div className="col-md-12">
                  {/* <form role="form" className="php-email-form needs-validation" id="form_ctct" novalidate> */}
                  <form id='webform4295798000022107021_contact' className="php-email-form needs-validation" action='https://crm.zoho.com/crm/WebToLeadForm' name='WebToLeads4295798000022107021' method='POST' accept-charset='UTF-8' target='_zoho_schedule_contact' onSubmit={onZohoFormSubmit} novalidate>
                    <input type='text' style={{ display: "none" }} name='xnQsjsdp' value='fc6dde5d64f353d0efdffeaa83d682d28c5703f9fa398c974d8d8ee31762ae9d'></input>
                    <input type='hidden' name='zc_gad' id='zc_gad' value=''/> 
                    <input type='text' style={{ display: "none" }}  name='xmIwtLD' value='5df38e5e8f23a4a1e4b1e6041ef0f13cb728081e8c8ce4e74582f9ac1fc82979f218b83c4cf6c07623e810c850271406'/> 
                    <input type='text' style={{ display: "none" }}  name='actionType' value='TGVhZHM='/> 
                    <input type='text' style={{ display: "none" }}  name='returnURL' value='https&#x3a;&#x2f;&#x2f;www.level1analytics.com&#x2f;'/> 
                    <div className="row">
                      <div className="col form-group">
                        <input type="text" className="form-control" id="First_Name" name="First Name" title="First Name" placeholder="First Name" aria-describedby="FirstName" required />
                        <div class="invalid-feedback">
                          Please provide your first name.
                        </div>
                      </div>
                      <div className="col form-group">
                        <input type="text" className="form-control" id="Last_Name" name="Last Name" title="Last Name" placeholder="Last Name" aria-describedby="LastName" required />
                        <div class="invalid-feedback">
                          Please provide your last name.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col form-group">
                        <input type="email" className="form-control" id="Email" name="Email" title="Email" placeholder="Email" aria-describedby="Email" required />
                          <div className="invalid-feedback">
                            Please provide your email.
                          </div>
                      </div>
                      <div className="col form-group">
                        <input type="phone" className="form-control" id="Phone" name="Phone" placeholder="Phone" aria-describedby="Phone" />
                      </div>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control" id="Company" name="Company" title="Company" placeholder="Company" aria-describedby="Company" required/>
                      <div className="invalid-feedback">
                        Please provide your company.
                      </div>
                    </div>
                    <div className="form-group col-center">
                      <ReCAPTCHA className='recaptcha-container'  ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                    </div>
                    {/* <div className="form-group">
                      <textarea className="form-control" id="txt_ctct_message" title="Message" placeholder="Message" aria-describedby="Message" required></textarea>
                        <div className="invalid-feedback">
                          Please provide your message.
                        </div>
                    </div> */}
                    <div className="my-3">
                      <div className="loading">Loading</div>
                      <div className="error-message"></div>
                      <div className="sent-message">Your message has been sent. Thank you!</div>
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary form-control" id="but_ctct_contactSubmit">
                        <i className="spinner-border spinner-border-sm buttonspinner" role="status" id="spinner-sendmail"></i> Send
                      </button>
                    </div>
                  </form>
                  <iframe src="about:blank" id="_zoho_schedule_contact" name="_zoho_schedule_contact" style={{height:0, width:0, position:'absolute', top:-200, left:-200}}></iframe>
                </div>
              </div>

            </div>
          </section>
        }
      </>
    )
}

export default Contact;
